// extracted by mini-css-extract-plugin
export var menuIcon = "_nn-0";
export var menuIconInline = "_nn-1";